<template>
<div class="chapter">
<div class="inner_page">
<section class="chapter" epub:type="chapter">
<p class="fig"><img alt="" height="48" src="images/logo-synthesis.jpg" width="150"/></p>
<p class="serpf" style="text-align:center;"><a class="page" id="pii"></a>A series in the history of chemistry, broadly construed, edited by Carin Berkowitz, Angela N. H. Creager, John E. Lesch, Lawrence M. Principe, Alan Rocke, and E. C. Spary, in partnership with the Science History Institute</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chi-shindell-0003.vue?336a194e